import { inject } from '@angular/core';
import { DsHeaderBarChipConfig } from '@levelaccess/design-system';
import { Observable } from 'rxjs';

import { StandardizedHeaderBarService } from './standardized-header-bar.service';

export abstract class StandardizedHeaderBarComponent {
  private readonly standardizedHeaderBarService: StandardizedHeaderBarService = inject(StandardizedHeaderBarService);

  protected readonly useStandardizedHeaderBar$: Observable<boolean> = this.standardizedHeaderBarService.useStandardizedHeaderBar$;
  protected readonly wayfindingChips$: Observable<DsHeaderBarChipConfig[]> =
    this.standardizedHeaderBarService.getWayfindingChipConfig$();
}
